export const navigation = [
  {
    text: 'MDOC Forms',
    icon: 'doc',
    path: '',
    items: [
      {
        text: 'Substance Abuse Treatment Referral',
        path: '/mdoc/sat-referral'
      },
      {
        text: 'Create Referral',
        path: '/mdoc/sat-referral/create'
      },
      {
        text: 'Download Consent Form',
        path: '/assets/Consent_to_Share_Behavioral_Health_Information_for_Care_Coordination_Purposes.pdf'
      }
    ]
  },
  {
    text: 'Admin',
    icon: 'card',
    path: '',
    items: [
      {
        text: 'Users',
        path: '/admin/users'
      },
      {
        text: 'Create User',
        path: '/admin/users/create'
      }
      // {
      //   text: 'Event Log',
      //   path: '/admin/event-log'
      // }
    ]
  }
];

export const devNavigation = [
  {
    text: 'CRM',
    icon: 'user',
    path: '',
    items: [
      {
        text: 'Contact List',
        path: '/crm-contact-list'
      },
      {
        text: 'Contact Details',
        path: '/crm-contact-details'
      }
    ]
  },
  {
    text: 'Planning',
    icon: 'event',
    path: '',
    items: [
      {
        text: 'Task List',
        path: '/planning-task-list'
      },
      {
        text: 'Task Details',
        path: '/planning-task-details'
      },
      {
        text: 'Scheduler',
        path: '/planning-scheduler'
      }
    ]
  },
  {
    text: 'Analytics',
    icon: 'chart',
    path: '',
    items: [
      {
        text: 'Dashboard',
        path: '/analytics-dashboard'
      },
      {
        text: 'Sales Report',
        path: '/analytics-sales-report'
      },
      {
        text: 'Geography',
        path: '/analytics-geography'
      }
    ]
  },
  {
    text: 'Common',
    icon: 'box',
    path: '',
    items: [
      {
        text: 'Sign In Form',
        path: '/sign-in-form'
      },
      {
        text: 'Sign Up Form',
        path: '/sign-up-form'
      },
      {
        text: 'Reset Password Form',
        path: '/reset-password-form'
      },
      {
        text: 'User Profile',
        path: '/user-profile'
      }
    ]
  }
];
